import { gql } from '@apollo/client/core';

const INITIATE_PAYMENT = gql`
  mutation InitiatePayment($input: InitiatePaymentInput!) {
    initiatePayment(input: $input) {
      paymentUrl
      hash
      rrr
      redirectUrl
      convenienceFee
      baseAmount
      totalAmount
      paymentMethod
      merchantCode
      payItemId
      customerEmail
      customerId
      customerName
      transactionReference
      amountInKobo
      currency
      paymentPageUrl
      inlineCheckoutUrl
      mode
      splitAccounts
    }
  }
`;

const SET_PAYMENT_PROVIDER = gql`
  mutation SetPaymentProvider($input: PaymentProviderInput!) {
    setPaymentProvider(input: $input) {
      id
      school_id
      name
      config {
        ... on MonnifyConfig {
          monnifyApiKey: apiKey
          secretKey
          contractCode
        }
        ... on RemitaConfig {
          remitaApiKey: apiKey
          serviceTypeId
          merchantId
        }
        ... on PaystackConfig {
          paystackApiKey: apiKey
        }
      }
    }
  }
`;

const TOGGLE_PAYMENT_PROVIDER = gql`
  mutation TogglePaymentProvider($id: ID!, $is_active: Boolean!) {
    togglePaymentProvider(id: $id, is_active: $is_active) {
      id
      name
      is_active
    }
  }
`;

const RECORD_MANUAL_PAYMENT = gql`
  mutation RecordManualPayment($input: RecordPaymentInput!) {
    recordPayment(input: $input) {
      id
      amount
      status
    }
  }
`;

export { INITIATE_PAYMENT, SET_PAYMENT_PROVIDER, TOGGLE_PAYMENT_PROVIDER, RECORD_MANUAL_PAYMENT };
